// vendor
import { createAction } from '@ngrx/store';

// local application
import { DialogTypes } from 'app/store/global/dialog/dialog.type';

export const setIsDialogOpeningAction = createAction(
  DialogTypes.Set_Is_Dialog_Opening,
  (payload: boolean = true) => ({
    payload,
  })
);

export const showErrorNotificationDialogAction = createAction(
  DialogTypes.Show_Error_Notification_Dialog,
  (payload: unknown) => ({
    payload,
  })
);

export const showSuccessNotificationDialogAction = createAction(
  DialogTypes.Show_Success_Notification_Dialog,
  (payload: unknown) => ({
    payload,
  })
);
